function Layout1(props) {
    return (
        <>
            {props.children}
        </>
    );
}

export default Layout1;
